import { useQuery } from '@apollo/client';
// Api
import { TICKETING_LAUNCHED } from 'api/ticketEvents/queries';
// Types
import { TicketingLaunched } from 'api/ticketEvents/types/TicketingLaunched';

/** The flag, and whether it has loaded, for screens whose layout depends on it. */
export const useTicketingLaunchedStatus = (): {
  launched: boolean;
  loaded: boolean;
} => {
  const { data, loading, error } = useQuery<TicketingLaunched>(
    TICKETING_LAUNCHED,
    { fetchPolicy: 'cache-first' }
  );

  return {
    launched: data?.ticketingLaunched === true,
    loaded: !loading || !!data || !!error,
  };
};

/** False until the flag loads, so no ticketing shows before launch. */
export const useTicketingLaunched = (): boolean =>
  useTicketingLaunchedStatus().launched;
